// Items for employment status
export const employmentStatusItems = [
  { value: 'EMPLOYED' },
  { value: 'INDEPENDENT' },
  { value: 'RETIRED' },
  { value: 'STUDENT' },
  { value: 'UNEMPLOYED' },
]

// Items for occupation
export const occupationItems = [
  { value: 'EDUCATION' },
  { value: 'ENGINEERING_SCIENCES' },
  { value: 'FINANCE' },
  { value: 'HEALTHCARE' },
  { value: 'LEGAL' },
  { value: 'MARKETING_ADVERTISING' },
  { value: 'PROFESSIONAL_SERVICES' },
  { value: 'SALES' },
  { value: 'TECHNOLOGY_IT' },
  { value: 'OTHER' },
]

// Items for Net Worth
export const netWorthRangeItems = [
  { value: 'BELOW_100K' },
  { value: 'BETWEEN_100K_AND_200K' },
  { value: 'BETWEEN_200K_AND_500K' },
  { value: 'BETWEEN_500K_AND_1M' },
  { value: 'BETWEEN_1M_AND_2M' },
  { value: 'BETWEEN_2M_AND_5M' },
  { value: 'OVER_5M' },
]

export const EMPLOYMENT_STATUS = 'employmentStatus'
export const OCCUPATION = 'occupation'
export const PERSONAL_NET_WORTH_RANGE = 'personalNetWorthRange'
